import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/GlobalCss/Style.css";
import "@/assets/GlobalCss/Typography.css";
import { BootstrapVue } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Vuelidate from "vuelidate";
import SubHeader from "@/components/CommonComponents/SubHeader.vue";
import LoaderComponent from "./components/FixedComponents/LoaderComponent.vue";
import FormInput from "@/components/InputComponents/FormInput.vue";
import SingleSelect from "@/components/InputComponents/SingleSelect.vue";
import MultiSelect from "@/components/InputComponents/MultiSelect.vue";
import DateFeild from "@/components/InputComponents/DatePicker.vue";
import TextArea from "@/components/InputComponents/TextArea.vue";
import PhoneNumber from "@/components/InputComponents/PhoneNumber.vue";
import PromoCode from "@/components/InputComponents/PromoCode.vue";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.component("SubHeader", SubHeader);
Vue.component("LoaderComponent", LoaderComponent);
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import io from "socket.io-client";
Vue.use(Vuelidate);
Vue.use(DatePicker);
const socket = io("https://keynode.simplifycv.com");

Vue.prototype.$socket = socket;

Vue.component("FormInput", FormInput);
Vue.component("SingleSelect", SingleSelect);
Vue.component("MultiSelect", MultiSelect);
Vue.component("DateFeild", DateFeild);
Vue.component("TextArea", TextArea);
Vue.component("PhoneNumber" , PhoneNumber)
Vue.component("PromoCode" , PromoCode)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

let handleOutsideClick;
Vue.directive("closable", {
  bind(el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation();

      const { handler, exclude } = binding.value || {};
      if (!handler) {
        console.error("Handler not provided in v-closable directive.");
        return;
      }

      // Check for excluded elements
      let clickedOnExcludedEl = false;
      exclude?.forEach((refName) => {
        if (!clickedOnExcludedEl) {
          let excludedEl = vnode.context.$refs[refName];
          excludedEl = excludedEl instanceof Vue ? excludedEl.$el : excludedEl;

          if (excludedEl?.contains(e.target)) {
            clickedOnExcludedEl = true;
          }
        }
      });

      // If clicked outside the element and not on excluded elements
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        if (typeof handler === "function") {
          // If the handler is a direct function, call it
          handler(e);
        } else if (typeof vnode.context[handler] === "function") {
          // If the handler is a method name, call it on the component context
          vnode.context[handler](e);
        } else {
          console.error(
            `Handler "${handler}" is not a function or method in the component context.`
          );
        }
      }
    };

    document.addEventListener("click", handleOutsideClick);
  },
  unbind() {
    document.removeEventListener("click", handleOutsideClick);
  },
});
